import { useTheme } from "react-jss";
import { useAppSelector } from "../../../../../redux/hooks";
import { RequestButtons } from "../buttons/requestButtons";
import { RequestUtiDataForm } from "./form/form";
import { IRequestStepProps } from "../../../../../models/requests/draft/IRequestStepProps";
import { CreateRequestContainerStyle } from "../containerStyle.jss";

export const UtiDataContainer: React.FC<IRequestStepProps> = (props) => {
    const theme = useTheme();
    const styles = CreateRequestContainerStyle({ theme });
    const { utiStepIsValid,  } = useAppSelector((store) => store.createRequest.sectionValidation);

    return (
        <>
            <div className={styles.stepperContainer}>
                <RequestUtiDataForm {...props} />
            </div>
            <RequestButtons
                isValid={utiStepIsValid}
                isLastStep={false}
                isFirstStep={true}
                schema={props.schema}
            />
        </>
    );
};
